<template>
  <b-container fluid>
    <!--  Temporarily close modal  -->
    <main-modal id="tempCloseModal" size="md" @unsavedMsg="unsavedMsg">
      <template v-slot:header>
        <h4 class="font-weight-bold"><span class="text-danger">Temporarily close: </span> Account</h4>
      </template>
      <template v-slot:body>
        <temp-msg-modal @setMsg="setTempCloseMsg"
                        :statusDetails="statusDetails"/>
      </template>
    </main-modal>
    <b-row>
      <b-col md="12" class="mb-2 d-flex justify-content-between align-items-center mb-4">
        <h3>Facility</h3>
          <b-card v-if="!loading">
            <span class="text-dark font-weight-bold font-size-14 mr-3">
              {{ statusDetails.status === 'visible'? 'Temporarily close account' : 'Temporarily closed account' }}
            </span>
            <div
                class="custom-control custom-switch custom-switch-text custom-control-inline custom-switch-color mr-0" >
              <div class="custom-switch-inner">
                <input type="checkbox" class="custom-control-input bg-danger" :id="'status'"
                       @change="changeStatus()" v-model="switchStatus">
                <label class="custom-control-label" :for="'status'">
                </label>
              </div>
            </div>
          </b-card>
         <!-- <b-form-radio class="custom-radio-color-checked mr-4" inline v-model="oldProfile.status" color="warning"
                       name="status" value="visible" @change="changeStatus(0)">
           <span class="text-primary font-size-14">Visible</span>
         </b-form-radio>
         <b-form-radio class="custom-radio-color-checked mr-4" inline v-model="oldProfile.status" color="warning"
                       name="status" value="invisible" @change="changeStatus(0)">
           <span class="text-primary font-size-14">Invisible</span>
         </b-form-radio>
         <b-form-radio class="custom-radio-color-checked mr-4" inline v-model="oldProfile.status" color="warning"
                       name="status" value="temp_closed" @change="changeStatus(1)">
           <span class="text-primary font-size-14">Temporarily closed</span>
         </b-form-radio> -->
      </b-col>
      <b-col md="12">
        <b-tabs content-class="mt-3">
          <b-tab title="Profile" active>
            <spinner-loading v-if="loading" text="Loading" />
            <business-tab
              v-else
              @updateFacilityInfo="updateFacilityInfo"
              @updateFacilityPhones="updateFacilityPhones"
              @updateFacilityOperatingDays="updateFacilityOperatingDays"
              @reload="getOldAdminInfo"
              :oldProfile="oldProfile"
            />
          </b-tab>

          <b-tab title="FAQs">
            <faq-tab />
          </b-tab>

          <b-tab title="Payment">
            <payment-tab />
          </b-tab>
        </b-tabs>
        <!-- <tab-nav :tabs="true" id="myTab-1">
          <tab-nav-items :active="true" id="business-tab" ariaControls="businessInfo"
                         role="tab" :ariaSelected="false" title="Profile" liClass="tab nav-item"/>
          <tab-nav-items :active="false" id="faq-tab" ariaControls="faq"
                         role="tab" :ariaSelected="false" title="FAQs" liClass="tab nav-item"/>
          <tab-nav-items :active="false" id="payment-tab" ariaControls="paymentInfo"
                         role="tab" :ariaSelected="false" title="Payment" liClass="tab nav-item"/>
        </tab-nav>
        <tab-content id="myTabContent">
          <tab-content-item :active="true" id="businessInfo" aria-labelledby="business-tab">
            <spinner-loading v-if=(loading) text="Loading" />
            <business-tab v-else
                          @updateFacilityInfo="updateFacilityInfo"
                          @updateFacilityPhones="updateFacilityPhones"
                          @updateFacilityOperatingDays="updateFacilityOperatingDays"
                          @reload="getOldAdminInfo"
                          :oldProfile="oldProfile"
            ></business-tab>
          </tab-content-item>
          <tab-content-item :active="false" id="faq" aria-labelledby="faq-tab">
            <faqTab />
          </tab-content-item>
          <tab-content-item :active="false" id="paymentInfo" aria-labelledby="payment-tab">
          <payment-tab></payment-tab>
          </tab-content-item>
        </tab-content> -->
      </b-col>
    </b-row>
  </b-container>
</template>

<script>

import { core } from '@/config/pluginInit'
import businessTab from '@/modules/business/profile/components/businessTab'
import faqTab from '@/modules/business/faqs/views/list.vue'
import paymentTab from '../components/paymentTab.vue'
import tempMsgModal from '@/modules/business/profile/components/tempMsgModal'
import profileServices from '@/modules/business/profile/services/profile.services'
import facilityInfoService from '@/modules/businessLandingPage/services/registration.services'

export default {
  data () {
    return {
      loading: true,
      oldProfile: '',
      id: '',
      statusDetails: {
        status: '',
        status_msg: ''
      },
      switchStatus: ''
    }
  },
  components: {
    tempMsgModal,
    // adminTab,
    businessTab,
    faqTab,
    paymentTab
  },
  methods: {
    changeStatus () {
      console.log(this.switchStatus)
      this.switchStatus ? this.$bvModal.show('tempCloseModal') : this.setStatus()
    },
    setStatus () {
      profileServices.changeStatus({ status: 'visible' }).then(res => {
        this.statusDetails.status = 'visible'
        core.showSnackbar('success', res.data.message)
      })
    },
    setTempCloseMsg (obj) {
      profileServices.changeStatus(obj).then(res => {
        this.statusDetails.status = 'temp_closed'
        this.$bvModal.hide('tempCloseModal')
        core.showSnackbar('success', res.data.message)
      })
    },
    unsavedMsg () {
      this.oldProfile.status = this.statusDetails.status
    },
    // Get data
    getOldAdminInfo () {
      this.id = JSON.parse(localStorage.getItem('userInfo')).id
      profileServices.getProfileData().then(res => {
        this.oldProfile = res.data.data
        this.statusDetails = { status: this.oldProfile.status, status_msg: this.oldProfile.status_msg }
        this.switchStatus = !(this.statusDetails.status === 'visible' || this.statusDetails.status === 'invisible')
        this.loading = false
      })
    },
    // Admin tab
    updateLoginCredential (credential) {
      console.log('credential', credential)
      profileServices.changePassword(credential).then(res => {
        core.showSnackbar('success', res.data.message)
      })
    },
    updateContactInfo (contact) {
      facilityInfoService.saveStepAdmin(contact).then(res => {
        core.showSnackbar('success', res.data.message)
      })
    },
    // Business tab
    updateFacilityInfo (info) {
      // facilityInfoService.saveStepFacility(info).then(res => {
      //   core.showSnackbar('success', res.data.message)
      // })
      profileServices.editProfileData(info).then(res => {
        core.showSnackbar('success', res.data.message)
      })
    },
    updateFacilityPhones (typeOfLocation, location) {
      debugger
      if (typeOfLocation === 'address based') {
        profileServices.editProfileData(location).then(res => {
          core.showSnackbar('success', res.data.message)
        })
      } else {
        profileServices.editProfileData(location).then(res => {
          core.showSnackbar('success', res.data.message)
        })
      }
    },
    updateFacilityOperatingDays (days) {
      profileServices.editProfileData(days).then(res => {
        core.showSnackbar('success', res.data.message)
      })
    }
  },

  created () {
    this.getOldAdminInfo()
  },

  mounted () {
    core.index()
  }
}
</script>
<style>
.temp-btn {
  background-color: white;
  padding: 12px 20px;
}

.tab {
  width: 200px;
  text-align: center;
}
</style>
